
    import { ApplicationInsights } from '@microsoft/applicationinsights-web';

    const connectionString = import.meta.env.VITE_APPINSIGHTS_CONNECTION_STRING;

    if (connectionString && connectionString.trim().length > 0 && connectionString !== 'YOUR_CONNECTION_STRING_HERE') {
        try {
            const appInsights = new ApplicationInsights({
                config: {
                    connectionString,
                    enableAutoRouteTracking: false
                }
            });

            appInsights.loadAppInsights();
            appInsights.trackPageView();
        } catch (error) {
            console.warn('Application Insights initialization failed.', error);
        }
    }
